var Handlebars = require("/Users/niall/projects/workflows-js/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "active";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<ul class=\"nav nav-tabs sidebar-tabs nav-fill\">\n    <li class=\"nav-item\">\n        <a class=\"nav-link add-edam-annotations "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.edam : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" href=\"javascript:void(0)\">EDAM annotation</a>\n    </li>\n    <li class=\"nav-item\">\n        <a class=\"nav-link add-assoc-resources "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.assoc : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" href=\"javascript:void(0)\">Associated resources</a>\n    </li>\n\n</ul>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/edit_mode/_tabs.hbs
// module id = 70
// module chunks = 0